import { title } from "process"
import czita from "../assets/images/partners/czita.png"
import vsp from "../assets/images/partners/vsp.png"
import vcz from "../assets/images/partners/vcz.png"
import topm from "../assets/images/partners/topm.png"




// Sample partners
export const partners = [
    {
        slug: "czita",
        title: "Czech IT Academy",
        logo: czita
    },
    {
        slug: "vsp",
        title: "VK Slavia Praha",
        logo: vsp
    },
    {
        slug: "vcz",
        title: "Včeluj.cz",
        logo: vcz
    },
    {
        slug: "topm",
        title: "Topofminders.cz",
        logo: topm
    }
]